__turbopack_context__.v({
  "faqAnswer": "FAQ-module__ngmWiq__faqAnswer",
  "faqContainer": "FAQ-module__ngmWiq__faqContainer",
  "faqIcon": "FAQ-module__ngmWiq__faqIcon",
  "faqItem": "FAQ-module__ngmWiq__faqItem",
  "faqList": "FAQ-module__ngmWiq__faqList",
  "faqQuestion": "FAQ-module__ngmWiq__faqQuestion",
  "open": "FAQ-module__ngmWiq__open",
  "title": "FAQ-module__ngmWiq__title",
});
